import React from "react";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { InfoOutlined } from "@mui/icons-material";
import { PrimaryButton } from "@/Components/v2/atoms/Button";

type BannerStyle = {
  title: string;
  description: string;
  style: {
    infoIcon: {
      color: string;
    };
  };
};

interface CreateActionBannerProps {
  onCreateClick: () => void;
  bannerStyle: BannerStyle;
}

const CreateActionBanner = ({ onCreateClick, bannerStyle }: CreateActionBannerProps) => {
  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" mr={6}>
        <Stack direction="row" spacing={1}>
          <InfoOutlined sx={{ ...bannerStyle.style.infoIcon, fontSize: 24 }} />
          <Stack>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              {bannerStyle.title}
            </Typography>
            <Typography variant="body2" maxWidth="900px">
              {bannerStyle.description}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center">
        <PrimaryButton onClick={onCreateClick} sx={{ whiteSpace: "nowrap" }}>
          Create Action Plan
        </PrimaryButton>
      </Stack>
    </>
  );
};

export default CreateActionBanner;
